import { render, staticRenderFns } from "./SquadManagement.vue?vue&type=template&id=efaedbfc&scoped=true"
import script from "./SquadManagement.vue?vue&type=script&lang=js"
export * from "./SquadManagement.vue?vue&type=script&lang=js"
import style0 from "./SquadManagement.vue?vue&type=style&index=0&id=efaedbfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaedbfc",
  null
  
)

export default component.exports